import {addGenericErrorToast} from '@albert-io/atomic';

import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

import {useStudentHomepageStore} from '../useStudentHomepageStore';

import {useStudentHomepageStudentLazyQuery} from './useStudent.queries.generated';

export default function useGetStudent() {
  const isStudentLoading = useStudentHomepageStore((state) => state.studentEmail === null);
  const setStudentEmail = useStudentHomepageStore((state) => state.setStudentEmail);

  const [runStudentQuery] = useStudentHomepageStudentLazyQuery();

  async function fetchStudent() {
    try {
      const id = masqueradeStore.getUserIdByMasqueradeState();
      if (!id) {
        throw new Error('No student id available to fetch the student by');
      }

      // A lazy query resolves with the failure on `error` instead of rejecting.
      const {data, error} = await runStudentQuery({variables: {id}});
      if (error) {
        throw error;
      }

      const email = data?.user?.email;
      if (!email) {
        throw new Error(`No student found for id ${id}`);
      }

      setStudentEmail(email);
    } catch (error) {
      console.error(error);
      addGenericErrorToast();
    }
  }

  return {fetchStudent, isStudentLoading};
}
